import { render, staticRenderFns } from "./bam-modal.vue?vue&type=template&id=52ab2789&scoped=true&"
import script from "./bam-modal.vue?vue&type=script&lang=js&"
export * from "./bam-modal.vue?vue&type=script&lang=js&"
import style0 from "./bam-modal.vue?vue&type=style&index=0&id=52ab2789&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ab2789",
  null
  
)

export default component.exports